// Angular
import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

/**
 * El servicio crea un elemento `<link rel="canonical">` en el <head> del documento HTML.
 */
@Injectable({
  providedIn: 'root',
})
export class CanonicalService {
  constructor(@Inject(DOCUMENT) private dom: any) {}

  /**
   * Ayuda a establecer la URL canónica de una página.
   * - Evita problemas de contenido duplicado para los motores de búsqueda
   * @param url - URL canónica de la página.
   */
  setCanonicalURL(url?: string): void {
    const canURL = url == undefined ? this.dom.URL : url;
    const link: HTMLLinkElement = this.dom.createElement('link');
    // link.setAttribute('rel', 'canonical');
    this.dom.head.appendChild(link);
    link.setAttribute('href', canURL);
  }
}
